<template>
  <ul 
    v-if="!loading"
    :class="{'internal-next-pages--isTouch': touch}"
    class="internal-next-pages">
    <li 
      v-if="services"
      class="internal-next-pages__item">
      <router-link :to="{ name: 'single-page', params: { slug: $_getPageSlug('Services') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4>perché<br>sceglierci</h4>
          <p>Una vasta gamma di prodotti per muro,<br> legno e ferro, ma anche accessori<br> e prodotti ecologici. Pronto magazzino,<br> consulenza tecnica e tanto altro ancora.</p>
          <span>Scopri perchè</span>
        </div>
      </router-link>
    </li>
    <li 
      v-if="quality"
      class="internal-next-pages__item">
      <router-link :to="{ name: 'single-page', params: { slug: $_getPageSlug('Quality') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4>Realizzazioni</h4>
          <p>Una serie di immagini degli edifici e gli ambienti<br> realizzati dai nostri clienti con i nostri prodotti.</p>
          <span>Scopri le realizzazioni</span>
        </div>
      </router-link>
    </li>
    <li 
      v-if="company"
      class="internal-next-pages__item">
      <router-link :to="{ name: 'single-page', params: { slug: $_getPageSlug('Company') } }">
        <div class="internal-next-pages__item__absolute-block">
          <h4>L’azienda</h4>
          <p>I clienti che si affidano ai nostri punti vendita<br> trovano un servizio clienti professionale e preparato,<br> con quasi 40 anni di esperienza alle spalle<br> che ha permesso di comprendere al meglio<br> le esigenze della clientela.</p>
          <span>Scopri l'azienda</span>
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import getSinglePages from '@/mixins/getSinglePages.js'

export default {
  name: 'InternalNextPages',
  mixins: [getSinglePages],
  props: {
    services: {
      type: Boolean,
      default: false
    },
    quality: {
      type: Boolean,
      default: false
    },
    company: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'touch'
    ])
  }
}
</script>

<style lang="scss">
  @import "./internal-next-pages.scss";
</style>
  